// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDGp44HRmXMuTXIbkdEwcZbXAYqv-wCpww",
    authDomain: "trica-a1d01.firebaseapp.com",
    projectId: "trica-a1d01",
    storageBucket: "trica-a1d01.firebasestorage.app",
    messagingSenderId: "785614296086",
    appId: "1:785614296086:web:5c3c641d721d63f6f21137"
};
// Initialize Firebase

export const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);